import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import LightbulbIcon from "@mui/icons-material/Lightbulb";

const Illuminance1Widget = ({ widget, onValueUpdate }) => {
  const [illuminance, setIlluminance] = useState(0);
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      setIlluminance(Number(widget.items.$w1.value));
      setIsFlashing(true);
      setTimeout(() => setIsFlashing(false), 500);
    }
  }, [widget]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        height: "100%",
        width: "100%",
        padding: 2,
        backgroundColor: isFlashing ? "secondary.main" : "background.default",
        borderRadius: 2,
        transition: "background-color 0.5s ease",
      }}
    >
      <Typography sx={{ fontSize: "1rem", fontWeight: 500 }}>
        {illuminance.toFixed(0)} lux
      </Typography>
      <LightbulbIcon
        sx={{
          fontSize: "1.2rem",
          color: "#FFD54F",
        }}
      />
    </Box>
  );
};

export default Illuminance1Widget;
